import type { ReactElement, ReactNode } from 'react';

export interface PageHeaderProps {
  title: string;
  description?: string;
  actions?: ReactNode;
}

export function PageHeader({ title, description, actions }: PageHeaderProps): ReactElement {
  return (
    <header className="flex flex-wrap items-end gap-4 mb-6 m-0 p-0 border-0 bg-transparent font-ui">
      <div className="flex-1 min-w-0 p-0 border-0 bg-transparent font-ui">
        <h1 className="m-0 text-2xl font-semibold text-ink p-0 border-0 bg-transparent font-ui">{title}</h1>
        {description ? <p className="mt-1 mb-0 text-md text-muted p-0 border-0 bg-transparent font-ui">{description}</p> : null}
      </div>
      {actions ? <div className="flex gap-2 p-0 border-0 bg-transparent font-ui">{actions}</div> : null}
    </header>
  );
}
